<div class="row justify-content-md-left">
   
    <br />
  <div class="col-xl-8">
    <form [formGroup]="formSelecionaPerfil">
    <mat-form-field class="full-width">
      <mat-select placeholder="Selecione Perfil"
        formControlName="perfilSelecionado" name="perfis"
        (ngModelChange)="validaPerfil()">
        <mat-option *ngFor="let item of perfis" [value]="item" [hidden]="item.visibildade===2">
          {{ item.descPerfil }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <small *ngIf="!perfis" class="erro">Selecione Perfil </small>
    </form>
  </div>
</div>

<div class="row justify-content-md-left " *ngIf="isPerfilRestrito">
  <div clas="col col-lg-8">

     <!--  <p><u>O perfil selecionado acima depende de autorização para sua confirmação.</u></p>
    <b> <p>Compareça a uma agência CAIXA com a documentação comprobatória ao perfil solicitado.</p></b>-->
    <b> <p>O perfil selecionado exige autorização para sua finalização.</p></b>
    <b> <p>Para sua autorização compareça a uma agência CAIXA com a documentação comprobatória.</p></b>
    <b> <p>Para confirmar o pré-registro, clique em "Confirmar".</p></b>
    <b> <p>Para interromper o pré-registro, clique em "Voltar".</p></b>

  </div>
</div>

<div *ngIf="criticaFugIso" class="row justify-content-md-left ">
  <div clas="col col-lg-8">
    <p class="erro">{{criticaFugIso['descRetorno'] === 'null' ? '' : criticaFugIso['descRetorno'] }} </p>
  </div>
</div>

<div *ngIf="isPerfilValido">
  
  <app-lista-servicos [perfil]="perfilSelecionado.value"></app-lista-servicos>

</div>
